<template>
  <div>
    <el-drawer
      :destroy-on-close="true"
      :append-to-body="true"
      title="Ayarlar"
      :visible.sync="settings"
      :with-header="false"
    >
      <div class="row" style="padding: 50px">
        <div class="col-md-12">
          <label for="">{{ $t("module.speed") }}</label>
          <el-slider
            v-model="speed"
            :step="1"
            :min="1"
            :max="speeds.length"
            show-stops
          ></el-slider>
        </div>
        <div class="col-md-12">
          <label for="">{{ $t("module.level") }}</label>
          <el-slider
            v-model="level"
            :step="1"
            :min="1"
            :max="7"
            show-stops
          ></el-slider>
        </div>
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">{{
            $t("module.autolevel")
          }}</label>
          <el-switch
            style="margin-top: 8px"
            v-model="autoLevel"
            :active-text="$t('module.yes')"
            :active-value="1"
            :inactive-value="0"
            :inactive-text="$t('module.no')"
          >
          </el-switch>
        </div>
      </div>
    </el-drawer>
    <div id="goz_esnetme">
      <paused
        v-if="pause"
        @click="
          $root.$emit('pause', !pause);
          pause = false;
        "
      ></paused>
      <a
        href="javascript:;"
        @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        "
        class="pause"
      >
        <i
          :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"
        ></i>
      </a>
      <a
        href="javascript:;"
        v-if="config == null || config == undefined"
        @click.stop="settings = true"
        class="settings"
      >
        <i class="el-icon-setting"></i>
      </a>

      <div id="question" style="padding: 25px; font-family: Roboto">
        <div
          style="
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-wrap: wrap;
            flex-direction: row;
          "
        >
          <template v-for="(i, index) in question.description">
            <span
              style="margin-right: 5px; display: inline-block; font-size: 16px"
              :style="{
                backgroundColor:
                  index == currentIndex && currentPart == 0 ? 'silver' : '',
              }"
              v-html="i.replace('<nl>', '')"
            ></span>
            <div
              v-if="i.indexOf('<nl>') != -1"
              style="width: 100%; height: 30px"
            ></div>
          </template>
        </div>

        <div
          style="
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-wrap: wrap;
            flex-direction: row;
            margin-top: 15px;
          "
        >
          <span
            style="
              margin-right: 5px;
              display: inline-block;
              font-weight: bold;
              font-size: 18px;
            "
            :style="{
              backgroundColor:
                index == currentIndex && currentPart == 1 ? 'silver' : '',
            }"
            v-for="(i, index) in question.title"
            >{{ i }}</span
          >
        </div>

        <ol
          v-if="showOptions"
          type="A"
          style="
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            flex-direction: column;
            margin-top: 20px;
            padding: 0;
            padding-left: 15px;
          "
        >
          <li
            @click="check(index)"
            style="font-weight: normal; font-size: 14px"
            :style="{ backgroundColor: getOptionClass(index) }"
            v-for="(i, index) in question.options"
          >
            {{ i.title }}
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "SoruEgzersizi",
  props: ["config"],
  data() {
    return {
      levelMap: {
        İlkokul: {
          path: "ilkokul",
          max: 26,
        },
        Ortaokul: {
          path: "ortaokul",
          max: 26,
        },
        Lise: {
          path: "lise",
          max: 26,
        },
        Yetişkin: {
          path: "yetiskin",
          max: 26,
        },
        LGS: {
          path: "lgs",
          max: 3,
        },
        YKS: {
          path: "yks",
          max: 26,
        },
        "Tüm Sınavlara Hazırlık": {
          path: "sinav",
          max: 26,
        },
      },
      pause: false,
      speed: 1,
      speeds: [400, 375, 350, 325, 300, 275, 250, 200],
      words: [],
      level: 1,
      currentLetter: null,
      lodash: _,
      wrapper: {
        width: 0,
        height: 0,
      },
      startDate: new Date().getTime(),
      endDate: null,
      skip: 0,
      end: false,
      settings: false,
      random: 0,
      autoLevel: 0,
      question: null,
      showOptions: false,
      currentPart: 0,
      currentIndex: 0,
      checkedOption: null,
    };
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
  },
  beforeDestroy() {
    clearInterval(this.interval);
    this.interval = null;
  },
  methods: {
    check(index) {
      this.checkedOption = {
        ...this.question.options[index],
        index,
      };

      setTimeout(() => {
        this.start();
      }, 2500);
    },
    getOptionClass(index) {
      if (this.checkedOption == null) return;
      var option = this.question.options[index];
      if (option.isTrue === true && this.checkedOption.index == index) {
        return "green";
      }
      if (
        this.checkedOption.index == index &&
        this.checkedOption != null &&
        option.isTrue === false
      ) {
        return "red";
      }
      if (
        this.checkedOption.index != index &&
        this.checkedOption != null &&
        option.isTrue === true
      ) {
        return "orange";
      }
      return "";
    },
    start() {
      this.currentIndex = 0;
      this.currentPart = 1;
      clearInterval(this.interval);
      this.interval = null;
      this.question = this.words[_.random(0, this.words.length - 1)];
      this.checkedOption = null;
      this.showOptions = false;

      this.interval = setInterval(() => {
        if (
          this.currentPart == 1 &&
          this.currentIndex == this.question.title.length - 1
        ) {
          this.currentPart = 0;
          this.currentIndex = 0;
          return;
        }

        if (
          this.currentPart == 0 &&
          this.currentIndex == this.question.description.length - 1
        ) {
          this.showOptions = true;
          clearInterval(this.interval);
          this.interval = null;
          return;
        }

        this.currentIndex += 1;
      }, this.speeds[this.speed - 1]);
    },
  },
  computed: {
    currentSpeed() {
      return this.speeds[this.speed - 1];
    },
  },
  watch: {
    currentSpeed: function () {
      clearInterval(this.interval);
      clearInterval(this.startInterval);
      this.start();
    },
    level: function () {
      clearInterval(this.interval);
      clearInterval(this.startInterval);
      this.start();
    },
  },
  created() {
    var levelMap = this.levelMap[this.$store.state.user.level];

    for (let index = 1; index <= levelMap.max; index++) {
      var m = require("../../assets/sorular/" +
        levelMap.path +
        "/" +
        index +
        ".js").default;
      console.log(m);
      this.words.push({
        ...m,
        title: m.title
          .replace(/\s\s+/g, " ")
          .replace(/[\n\r]/g, "")
          .trim()
          .split(" ")
          .filter((k) => k.trim() != ""),
        description: m.description
          .replace(/\s\s+/g, " ")
          .replace(/[\n\r]/g, "")
          .trim()
          .split(" ")
          .filter((k) => k.trim() != ""),
      });
    }

    this.start();

    if (this.config != null && this.config != undefined) {
      if (this.config.level != null && this.config.level != "")
        this.level = this.config.level;
      if (this.config.speed != null && this.config.speed != "")
        this.speed = this.config.speed;
      this.autoLevel = this.config.auto_level;
    }
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  height: 500px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  background: white;
  background-color: #ffffff;
  background-image: url("https://www.transparenttextures.com/patterns/45-degree-fabric-light.png");

  ol {
    margin: 0px;
    padding: 0px;
    padding-left: 15px;

    li {
      cursor: pointer;

      &:hover {
        background: white;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/modules/SoruEgzersizi.vue